import { type ReactNode } from "react";

interface TabbarItemProps {
  icon: ReactNode;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

function TabbarItem({ icon, label, isActive, onClick }: TabbarItemProps) {
  const handleClick = () => {
    // Trigger haptic feedback if available
    if (window.Telegram?.WebApp?.HapticFeedback) {
      window.Telegram.WebApp.HapticFeedback.impactOccurred("light");
    }
    onClick();
  };

  return (
    <button
      className={`tabbar-item ${isActive ? "active" : ""}`}
      onClick={handleClick}
      aria-label={label}
      type="button"
    >
      <span className="tabbar-icon">{icon}</span>
      <span className="tabbar-label">{label}</span>
      {isActive && <span className="tabbar-indicator" />}
    </button>
  );
}

export default TabbarItem;
